import React from "react"

function test(propeeee)
{
 
    alert("Great Shot!");
 
}

const Card = ({ heading, paragraph, imgUrl, projectLink }) => {
  return (
    <a
    href={projectLink ? projectLink : "#"}
    target="_self"
    rel="noopener noreferrer"
    className="btn"
    >
    <div

   
      className="card"
      style={{

        backgroundImage:
          "linear-gradient(to bottom, rgba(0, 255, 252, 0),rgba(0, 0, 0, 0.6)),url(" +
          imgUrl +
          ")",
      }}

    >
      <div className="content" >
       
          {/* <h1>CUSTOM STUFF</h1> */}
          <h1 className="header">{heading}</h1>
          <p className="text">{paragraph}</p>

      </div>
    </div>
        </a>
  )
}

export default Card
